import { lang } from '@umu/ukit-lang';
/**
 * @description 下载
 * @liushuai
 */
import { $window } from '@umu/umu-dom';
import { downloadFile } from '@umu/umu-api';
import React from 'react';
import { httpToHttps } from '@umu/umu-util';
import guideImg from '../images/file_download_guide.png';
import { Modal } from '@umu/umu-design';


// 收敛各类下载及参数
export enum DOWNLOAD_TYPE {
    ASSESSMENT_USER_RECORD = 'AssessmentUserRecord',
    SEARCHHITDETAILLIST = 'SearchHitDetailList',
    ASSESSMENT_MERGER_RECORD = 'AssessmentMergerRecord',
    ASSESSMENT_TASK_RECORD = 'AssessmentTaskRecord', // 测评任务总记录
    ASSESSMENT_TASK_ASSESSEE_RECORD = 'AssessmentTaskAssesseeRecord', // 被测者记录数据
    ASSESSMENT_TASK_ASSESSOR_RECORD = 'AssessmentTaskAssessorRecord', // 测评师记录数据
    USE_PRACTICE_HOMEWORK_RECORD = 'PracticeHomeworkList', // 测评师记录数据
}

// AssessmentUserRecord的参数结构
export interface IAssessmentUserRecordParams {
    assessment_id: string;
    download_type?: 'api';
    assessor_umu_id?: string;
    assessee_umu_id?: string;
    time_range?: string; // "1607586444,1607586449" 时间范围字符串；string类型逗号分割起止时间戳
}

export const downloadFileByOpenWindow = async (type: DOWNLOAD_TYPE, params: string) => {
    if (!type) {
        return;
    }

    const outputReportParmes = {
        class: type,
        params,
    };
    const res = await downloadFile(outputReportParmes);
    if (res && res.data) {
        const data = res.data || {};
        if (Number(data.status) === 0) {
            $window.location.href = httpToHttps(data.download_url);
        } else {
            Modal.confirm({
                centered: true,
                title: lang('温馨提示'),
                content: (
                    <div>
                        {lang('由于文件较大，正在后台生成中，请前往【消息中心】-【系统消息】下载。本弹窗可以关闭。')}
                        <img src={guideImg} alt="" width="100%" style={{ marginTop: '0.1rem' }} />
                    </div>
                ),
                cancelText: '',
                okText: lang('知道了'),
                okButtonProps: {
                    style: { backgroundColor: '#1e6ee6', borderColor: '#1e6ee6' },
                },
            });
        }
    }
};
